import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

// Use hero image for guide section
const GUIDE_IMAGE = "https://customer-assets.emergentagent.com/job_peak-mastery/artifacts/vxkjfdze_new%20version.jpg";

// Media logos - updated
const STANFORD_LOGO = "https://customer-assets.emergentagent.com/job_peak-mastery/artifacts/6tzly1zr_images%20%281%29.png";
const TEDX_LOGO = "https://customer-assets.emergentagent.com/job_peak-mastery/artifacts/k8lz0z30_ted%20x%20logo.png";
const INC_LOGO = "https://customer-assets.emergentagent.com/job_peak-mastery/artifacts/8pz1vs4v_oso_inc.svg";
const MINDVALLEY_LOGO = "https://customer-assets.emergentagent.com/job_peak-mastery/artifacts/i8nvdu0o_OSO_mindvalley.png";

export const GuideSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const mediaLogos = [
    { name: 'Stanford Business', url: STANFORD_LOGO },
    { name: 'TEDx', url: TEDX_LOGO },
    { name: 'Mindvalley', url: MINDVALLEY_LOGO },
    { name: 'Inc.', url: INC_LOGO },
  ];

  return (
    <section
      data-testid="guide-section"
      ref={ref}
      className="py-16 md:py-24 lg:py-32 bg-white relative overflow-hidden"
    >
      <div className="container-peak">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="relative order-2 lg:order-1"
          >
            <div className="relative max-w-md mx-auto lg:mx-0">
              {/* Decorative frame */}
              <div className="absolute -top-3 -left-3 lg:-top-4 lg:-left-4 w-full h-full border border-[#D97904]/30" />
              
              <img
                src={GUIDE_IMAGE}
                alt="Shayamal Vallabhjee"
                className="w-full h-auto object-contain relative z-10"
              />
              
              {/* Accent block */}
              <div className="absolute -bottom-3 -right-3 lg:-bottom-4 lg:-right-4 w-16 lg:w-24 h-16 lg:h-24 bg-[#D97904]/10 -z-10" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="order-1 lg:order-2 text-center lg:text-left"
          >
            <span className="section-tag block mb-4 lg:mb-6">Meet Your Guide</span>
            
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-light leading-[1.15] mb-3 lg:mb-4 text-[#1F2A44]">
              Shayamal Vallabhjee
            </h2>
            
            <p className="text-[#D97904] font-['Syne'] text-xs lg:text-sm uppercase tracking-wider mb-6 lg:mb-8">
              Human Performance Designer
            </p>

            <div className="space-y-4 lg:space-y-5 mb-8 lg:mb-10">
              <p className="text-[#5A6B7A] text-sm lg:text-base leading-relaxed">
                Shayamal Vallabhjee has spent over two decades working with the world's top Olympic athletes, teams, and business leaders — from FC Barcelona to Fortune 500 executives.
              </p>
              <p className="text-[#5A6B7A] text-sm lg:text-base leading-relaxed">
                He is a faculty member at <strong className="text-[#1F2A44]">Stanford Graduate School of Business</strong> and the author of <em>Breathe. Believe. Balance.</em> which has sold more than 50,000 copies worldwide.
              </p>
            </div>

            {/* Logos */}
            <div>
              <p className="text-[10px] lg:text-[11px] tracking-[0.25em] uppercase text-[#5A6B7A] mb-4 font-['Syne']">
                As Seen In:
              </p>
              <div className="flex items-center justify-center lg:justify-start gap-6 lg:gap-8 flex-wrap">
                {mediaLogos.map((logo) => (
                  <div key={logo.name} className="w-16 lg:w-20 h-8 lg:h-10 flex items-center justify-center">
                    <img
                      src={logo.url}
                      alt={logo.name}
                      className="max-w-full max-h-full object-contain"
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default GuideSection;
